const scheduledServicesUsersList = {
  title: 'Responsables'
}

export default scheduledServicesUsersList;